import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CertificateMenu from "./CertificateMenu";
import ChallanMenu from "./ChallanMenu";
import { Link, useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";
import logo from "./Geekay-logo.png";
import BillingMenu from "./BillingMenu";

export default function Menubar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  var fullname = localStorage.getItem("auth_name");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  return (
    <div> <ThemeProvider theme={theme}>
      <Button color='apple'
      position='static'
      style={{ fontWeight: '1000', fontSize: '17px' }}
      display="flex"
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Master
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem component={Link} to="/certificates/usermaster" onClick={handleClose} color="apple">User Master</MenuItem>
        <MenuItem component={Link} to="/certificates/customermaster" onClick={handleClose}>Customer Master</MenuItem>
        <MenuItem component={Link} to="/certificates/product" onClick={handleClose}>Category Master</MenuItem>
        <MenuItem component={Link} to="/certificates/subcategory" onClick={handleClose}>Sub Category Master</MenuItem>
        <MenuItem component={Link} to="/certificates/categorydetails" onClick={handleClose}>Category Details</MenuItem>
        {/*<MenuItem component={Link} to="/challan" onClick={handleClose}>Challan</MenuItem>*/}
        <MenuItem component={Link} to="/certificates/show_serial" onClick={handleClose}>Serial Master</MenuItem>
        <MenuItem component={Link} to="/certificates/show_listmonth" onClick={handleClose}>Month Master</MenuItem>
        
      </Menu>
      <Button color='apple'
      
      position='static'
      style={{ fontWeight: '1000', fontSize: '17px',color:'#A38A00' }}
      display="flex"
      id="basic-button"
      // component={Link} to="/certificates/show_chalans" onClick={handleClose}
      >
        <ChallanMenu/>
      </Button>
      <Button color='apple'
      
      position='static'
      style={{ fontWeight: '1000', fontSize: '17px',color:'#A38A00' }}
      display="flex"
      id="basic-button"
      >
        <CertificateMenu/>
      </Button>
      <Button color='apple'
      position='static'
      component={Link} to="/certificates/download_report"
      style={{ fontWeight: '1000', fontSize: '17px',color:'#A38A00' }}
      display="flex"
      id="basic-button"
      >
        Download Report
      </Button>
      
                      <Button color='apple'
      position='static'
      // component={Link} to="/certificates/billing"
      style={{ fontWeight: '1000', fontSize: '17px',color:'#A38A00' }}
      display="flex"
      id="basic-button"
      >
      <BillingMenu/>
      </Button>
      
      <div
      color='apple'
      component={Link} to="/certificates/usermaster"
      position='static'
      style={{ fontWeight: '1000', fontSize: '17px',color:'#A38A00' }}
      display="flex"
      >
      </div>
      </ThemeProvider>
      

      
    </div>
  );
}
